import { PasswordStrength } from '@app/core/enums/sign-in.enum';

export class AppConstant {
  // Object Constants
  public static readonly TransactionFilter = [
    { value: 'all', viewValue: 'All' },
    { value: 'recharges', viewValue: 'Recharges' },
    { value: 'rewards', viewValue: 'Rewards' },
    { value: 'coins', viewValue: 'Coins' },
  ];

  public static readonly DateFormat = {
    dateFormat: 'DD-MM-YYYY',
    datetimeFormat: 'DD-MM-YYYY hh:mm A',
    displayDateFormat: 'dd-MM-yyyy',
    dateInputFormat: 'DD/MM/YYYY',
  };

  public static readonly innerHtmlText = {
    videoErrorMessage:
      "<h1>We are experiencing video playback issues in some of the browsers.</h1> <br /> <p>Please try the following troubleshoot steps:</p><ul class = 'abc-cms-listing'><li><i class = 'arrow'></i>Log out and log back into ABC Talkies.</li><li><i class = 'arrow'></i>Refresh your browser or try playing with a different browser.</li><li><i class = 'arrow'></i>Try playing with a different internet connection.</li></ul><p>If you are still facing similar issues, we request you to reach out to us at <a class = 'abc-border-center-hover-effect' href = 'tel:+91 98733 08733' title = '+91 98733 08733'>+91 98733 08733</a> or mail us at <a class = 'abc-border-center-hover-effect' href = 'mailto:support@abctalkies.com' title = 'support@abctalkies.com'>support@abctalkies.com</a> with film details, we will assist you</p>",
    replayIcon:
      "<a class='abc-replay-icon' title='Replay' aria-label='Replay'></a>",
  };

  public static readonly HomePageIconUrl = {
    AppStoreLink: 'https://apps.apple.com/us/app/abc-talkies/id1586757822',
    PlayStoreLink:
      'https://play.google.com/store/apps/details?id=abctalkies.boxoffice.android',
    YouTubeLink: 'https://www.youtube.com/watch?v=c1XGQIJQiZw',
  };

  public static readonly VideoFormat = [
    'video/mp4',
    'video/webm',
    'video/mpg',
    'video/mpeg',
    'video/quicktime',
    'video/x-quicktime',
    'video/avi',
  ];

  public static readonly FilmListText = {
    divSection: '<div class="abc-reject-status"><h6>',
    rejectedText: 'Publishing status: <span>Rejected</span>',
    closingSection: '</h6><p>',
    closeDiv: '</p></div>',
  };

  public static readonly StaticUrl = {
    datePickerCss:
      'https://cdn.jsdelivr.net/npm/ngx-bootstrap@6.2.0/datepicker/bs-datepicker.css',
    cashFree: 'https://www.cashfree.com/assets/cashfree.sdk.v1.2.js',
    videoJs: 'https://vjs.zencdn.net/7.12.3/video.min.js',
    videoJsLink: 'https://vjs.zencdn.net/7.12.3/video-js.css',
    videoQualityLink:
      'https://unpkg.com/@silvermine/videojs-quality-selector/dist/css/quality-selector.css',
    videoJsHttpStreaming:
      'https://cdn.jsdelivr.net/npm/@videojs/http-streaming@2.14.0/+esm',
    videoJsQualityLevels:
      'https://cdn.jsdelivr.net/npm/videojs-contrib-quality-levels@2.1.0/dist/videojs-contrib-quality-levels.min.js',
    hlsQualitySelector:
      'https://cdn.jsdelivr.net/npm/videojs-hls-quality-selector@1.1.1/dist/videojs-hls-quality-selector.min.js',
    hlsQualitySelectorStyles:
      'https://cdn.jsdelivr.net/npm/videojs-hls-quality-selector@1.1.1/dist/videojs-hls-quality-selector.min.css',
    seekJs:
      'https://cdn.jsdelivr.net/npm/videojs-seek-buttons@2.1.0/dist/videojs-seek-buttons.js',
    seekLink:
      'https://cdn.jsdelivr.net/npm/videojs-seek-buttons@2.1.0/dist/videojs-seek-buttons.css',
    vastPlugin:
      'https://cdn.jsdelivr.net/npm/videojs-vast-vpaid@3.0.0-beta.8/dist/videojs_5.vast.vpaid.min.js',
    contribAds:
      'https://cdn.jsdelivr.net/npm/videojs-contrib-ads@6.9.0/dist/videojs-contrib-ads.min.js',
    imaPlugin: 'https://imasdk.googleapis.com/js/sdkloader/ima3.js',

    intelInput:
      'https://cdn.jsdelivr.net/npm/intl-tel-input@17.0.13/build/js/intlTelInput.min.js',
    intelInputCss:
      'https://cdn.jsdelivr.net/npm/intl-tel-input@17.0.13/build/css/intlTelInput.min.css',
    dataTableLink:
      'https://cdn.datatables.net/1.11.2/css/jquery.dataTables.min.css',
    dataTableCssLink:
      'https://cdn.datatables.net/responsive/2.2.7/css/responsive.dataTables.min.css',
    dataTableScript:
      'https://cdn.datatables.net/1.11.2/js/jquery.dataTables.min.js',
    dataTableCssScript:
      'https://cdn.datatables.net/responsive/2.2.7/js/dataTables.responsive.min.js',
    videoQualityScript:
      'https://unpkg.com/@silvermine/videojs-quality-selector/dist/js/silvermine-videojs-quality-selector.min.js',
    bigShortUrl: 'https://bigshorts.abcfilmfactory.com/',
    careersUrl: 'https://abctalkies.in/careers',
  };

  public static readonly TransactionStatus = {
    success: 'SUCCESS',
    fail: 'FAILED',
  };

  public static readonly EnabledAnalyticsServices = {
    clevertap: true,
    googleAnalytics: true,
    facebookPixel: true,
  };

  public static readonly IndianDetails = {
    indianDialCode: '+91',
    indianCountryCode: 'IN',
    currencySymbol: '₹',
    currencyCode: 'INR',
    defaultLanguage: 'en',
  };

  public static readonly Keys = {
    otpTimer: 'otpTimer',
    isTimerComplete: 'isTimerComplete',
    isPageValid: 'isPageValid',
    rewardCredit: 'Reward Credit',
    user: '_user',
    deviceId: 'deviceId',
  };

  public static readonly Regex = {
    password:
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,20}$/,
    mobile: /^\d{10}$/,
    email: /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/,
    safeURL: /^https?:\/\/[^\s]+$/i,
    sequential: /(123|abc|qwerty|111|aaaa)/i,
    socialMedia: {
      instagram:
        /^(https?:\/\/)?(www\.)?instagram\.com\/[a-zA-Z0-9._-]+\/?(\?.*)?$/,
      twitter: /^(https?:\/\/)?(www\.)?x\.com\/\w+\/?(\?.*)?$/,
      facebook:
        /^(https?:\/\/)?(www\.)?facebook\.com\/[a-zA-Z0-9.]+\/?(\?.*)?$/,
      linkedin:
        /^(https?:\/\/)?(www\.)?linkedin\.com\/in\/[a-zA-Z0-9-]+\/?(\?.*)?$/,
    },
  };

  public static readonly Title = {
    scratchWin: 'Scratch & Win',
    rewardUnlock: 'Reward Unlocked',
    chooseReward: 'Choose Your Reward',
  };

  public static readonly Messages = {
    chooseMovie: `Select one of the available movies from the list below. Don't miss out on the chance.`,
    scratchUnlock: `Congratulations! You've unlocked your reward. Enjoy your exclusive access to amazing surprises and have a great time!`,
    scratchLock: `Scratch the card to reveal your reward and unlock amazing surprises. Good luck and have fun!`,
    copyMessage: `Coupon code copied to clipboard!`,
    unavailableCopy: `Coupon code is unavailable to copy.`,
    fetchingPayment: `Fetching payment details...`,
    teaserOrientation: `Teaser must be in landscape orientation.`,
    trailerOrientation: `Trailer must be in landscape orientation.`,
    movieOrientation: `Only landscape videos are allowed for film uploads. Portrait orientation is not supported.`,
  };

  // Video Resolutions
  public static readonly VideoResolutions = {
    FHD: {
      Width: 1920,
      Height: 1080,
    },
    HD: {
      Width: 1280,
      Height: 720,
    },
    SD: {
      Width: 640,
      Height: 360,
    },
    QHD: {
      Width: 2560,
      Height: 1440,
    },
    UHD: {
      Width: 3840,
      Height: 2160,
    },
    HDPlus: {
      Width: 1600,
      Height: 900,
    },
    '4K': {
      Width: 4096,
      Height: 2160,
    },
  };

  public static readonly PORT = {
    BadRequest: 400,
    Unauthorized: 401,
    Forbidden: 403,
    NotFound: 404,
  };

  // Object Constants Ends

  // Single Constants
  public static readonly SUFFICIENT_VIDEO_PROGRESS = 95;
  public static readonly PAYMENT_GATEWAY = 'Cashfree';
  public static readonly BRAND = 'ABC Talkies';
  public static readonly DEVICE_TYPE = 'web';
  public static readonly OTP_RESEND_DURATION_IN_SEC = 120;
  public static readonly OTP_VALID_DURATION_IN_SEC = 600;
  public static readonly MIN_PASSWORD_STRENGTH = PasswordStrength.Strong;
  public static readonly PROGRESS_SEND_DURATION = 5000;
  public static readonly SCRATCH_SUFFICIENT_PERCENTAGE = 40;
  public static readonly SCRATCH_CONTENT_VISIBLE_PERCENTAGE = 10;
  public static readonly PAYMENT_WAIT_DURATION = 3000;
  public static readonly MAX_VIDEO_SIZE_GB = 25; // 25GB
  public static readonly SUCCESS_PAGE_GET_BACK_REDIRECT_DURATION = 5000;
  // Single Constants Ends
}

export const DeviceName = {
  iOS: 'iOS',
  mac: 'Mac',
  android: 'android',
  web: 'web',
};
